import {
  CheckCircle2,
  CircleX,
  LoaderCircle,
  Pause,
  Play,
  RotateCcw,
} from "lucide-react";

import type {
  Task,
} from "./types";

export type TaskAction =
  | "start"
  | "pause"
  | "complete"
  | "fail";

interface TaskActionButtonsProperties {
  task: Task;
  busyAction: TaskAction | null;

  onAction:
    (action: TaskAction) => void;
}

function ActionContent({
  busy,
  icon,
  text,
}: {
  busy: boolean;
  icon: React.ReactNode;
  text: string;
}) {
  if (busy) {
    return (
      <>
        <LoaderCircle
          size={15}
          className="rotating"
        />

        <span>Выполняем…</span>
      </>
    );
  }

  return (
    <>
      {icon}
      <span>{text}</span>
    </>
  );
}

function TaskActionButtons({
  task,
  busyAction,
  onAction,
}: TaskActionButtonsProperties) {
  const isBusy = busyAction !== null;

  if (
    task.status === "completed"
    || task.status === "failed"
  ) {
    return null;
  }

  const taskIsRunning =
    task.status === "in_progress";

  const taskIsWaiting =
    task.status === "waiting";

  const mainAction: TaskAction =
    taskIsRunning
      ? "pause"
      : "start";

  const mainLabel =
    taskIsRunning
      ? "Пауза"
      : taskIsWaiting
        ? "Продолжить"
        : "Запустить";

  const mainIcon =
    taskIsRunning
      ? <Pause size={15} />
      : taskIsWaiting
        ? <RotateCcw size={15} />
        : <Play size={15} />;

  return (
    <div className="task-action-buttons">
      <button
        type="button"
        className={[
          "task-action-button",
          taskIsRunning
            ? "task-action-pause"
            : "task-action-start",
        ].join(" ")}
        onClick={() => {
          onAction(mainAction);
        }}
        disabled={isBusy}
        title={mainLabel}
      >
        <ActionContent
          busy={busyAction === mainAction}
          icon={mainIcon}
          text={mainLabel}
        />
      </button>

      <button
        type="button"
        className={[
          "task-action-button",
          "task-action-complete",
        ].join(" ")}
        onClick={() => {
          onAction("complete");
        }}
        disabled={isBusy}
        title="Завершить задачу"
      >
        <ActionContent
          busy={busyAction === "complete"}
          icon={<CheckCircle2 size={15} />}
          text="Завершить"
        />
      </button>

      <button
        type="button"
        className={[
          "task-action-button",
          "task-action-fail",
        ].join(" ")}
        onClick={() => {
          onAction("fail");
        }}
        disabled={isBusy}
        title="Отметить задачу проваленной"
      >
        <ActionContent
          busy={busyAction === "fail"}
          icon={<CircleX size={15} />}
          text="Провалена"
        />
      </button>
    </div>
  );
}

export default TaskActionButtons;
